export const isNotIncludedIn = (arr: any[]) => (item: any) =>
  !arr.includes(item)
